import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

const REVIEW_FLAG =
  "DRAFT — placeholder copy pending final legal review before public launch.";

const LegalLayout = ({ title, testid, children }) => (
  <main className="min-h-screen bg-paper" data-testid={testid}>
    <Nav />
    <div className="mx-auto max-w-2xl px-5 md:px-8 pt-36 md:pt-44 pb-28">
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-ink">{title}</h1>
      <p className="mt-4 text-xs tracking-[0.15em] uppercase text-ink/40" data-testid="legal-review-flag">
        {REVIEW_FLAG}
      </p>
      <div className="mt-10 space-y-6 text-base leading-relaxed text-ink/70">
        {children}
      </div>
    </div>
    <Footer />
  </main>
);

export const PrivacyPage = () => (
  <LegalLayout title="Privacy Policy" testid="privacy-page">
    <p>
      Walk It Through collects only the information needed to arrange and
      prepare for your conversation: your first name, contact details, and your
      answers to the short pre-call questions.
    </p>
    <p>
      Your information is stored securely, treated as sensitive, and never
      sold, shared or published. Pre-call answers are visible only to Luke.
    </p>
    <p>
      We keep simple, anonymous counts of page visits and button clicks to
      understand whether the site is useful. We do not use invasive tracking or
      advertising cookies.
    </p>
    <p>
      You can ask at any time to see, correct or delete the information held
      about you by messaging Luke directly.
    </p>
  </LegalLayout>
);

export const TermsPage = () => (
  <LegalLayout title="Terms" testid="terms-page">
    <p>
      Walk It Through provides calm, independent, non-judgemental conversation
      and perspective for people navigating separation, co-parenting and
      changing family relationships. It is a paid conversation service
      delivered by Luke.
    </p>
    <p>
      Walk It Through does not provide legal, financial, medical, therapeutic
      or emergency advice or services, and nothing in a conversation should be
      relied upon as such. Qualified professionals handle the professional
      decisions.
    </p>
    <p>
      The First Walk (£60, 30 minutes) is paid in full at booking. A booking is
      only confirmed once payment has completed successfully.
    </p>
    <p>
      Walk With Me (£495/month) is offered by agreement after a First Walk and
      is arranged directly — it is not purchased online.
    </p>
    <p>
      Walk It Through is not an emergency service and between-call messaging
      does not promise instant availability. If you are in immediate danger or
      crisis, contact the appropriate emergency or professional service.
    </p>
  </LegalLayout>
);

export const CancellationPage = () => (
  <LegalLayout title="Cancellation Policy" testid="cancellation-page">
    <p>
      Life is complicated enough. You can cancel or reschedule your First Walk
      up to 24 hours before the arranged time for a full refund — just message
      Luke directly.
    </p>
    <p>
      Inside 24 hours, refunds are at Luke’s discretion — but if something
      genuinely urgent has come up, say so and we’ll sort something out.
    </p>
    <p>
      Once a conversation has taken place, it isn’t refundable.
    </p>
    <p>
      If Luke ever needs to reschedule, you’ll be offered a new time or a full
      refund, whichever you prefer.
    </p>
  </LegalLayout>
);
